import React from "react";
import { PopupMenu, SearchFilterInput } from "@thenounproject/lingo-core";

import { SearchQueryFilterOption } from "../types";
import { getDaysAgoRange, getTodayDateRange, getYesterdayDateRange } from "@helpers/dates";

type Props = {
  filter: SearchQueryFilterOption;
  onSelectFilter: (filter: SearchFilterInput) => void;
  onSelectDateInputType: (type: "exact" | "range") => void;
  onSelectFilterOption?: (filter: SearchQueryFilterOption) => void;
};
const AssetLibraryDateFilterOptions: React.FC<Props> = ({
  filter,
  onSelectFilter,
  onSelectFilterOption,
  onSelectDateInputType,
}) => {
  return (
    <>
      <PopupMenu.Item
        title="Today"
        onClick={() => {
          onSelectFilter({
            type: filter.type,
            fieldId: filter.fieldId,
            id: `${filter.type}-${filter.fieldId}-today`,
            display: "Today",
            operatorValues: getTodayDateRange(),
          });
        }}
      />
      <PopupMenu.Item
        title="Yesterday"
        onClick={() => {
          onSelectFilter({
            type: filter.type,
            fieldId: filter.fieldId,
            id: `${filter.type}-${filter.fieldId}-yesterday`,
            display: "Yesterday",
            operatorValues: getYesterdayDateRange(),
          });
        }}
      />
      <PopupMenu.Item
        title="Last 7 Days"
        onClick={() => {
          onSelectFilter({
            type: filter.type,
            fieldId: filter.fieldId,
            id: `${filter.type}-${filter.fieldId}-last-7-days`,
            display: "Last 7 Days",
            operatorValues: getDaysAgoRange(7),
          });
        }}
      />
      <PopupMenu.Item
        title="Last 30 Days"
        onClick={() => {
          onSelectFilter({
            type: filter.type,
            fieldId: filter.fieldId,
            id: `${filter.type}-${filter.fieldId}-last-30-days`,
            display: "Last 30 Days",
            operatorValues: getDaysAgoRange(30),
          });
        }}
      />
      <PopupMenu.Item
        title="Custom Date"
        onClick={() => {
          onSelectFilterOption?.(filter);
          onSelectDateInputType("range");
        }}
      />
    </>
  );
};

export default AssetLibraryDateFilterOptions;
